import * as React from 'react';
const YouTube = ({ youTubeId })=>React.createElement("div", {
        className: "mdx-embed",
        style: {
            aspectRatio: '16 / 9'
        }
    }, React.createElement("iframe", {
        src: `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youTubeId)}`,
        title: "YouTube video",
        width: "100%",
        height: "100%",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        allowFullScreen: true,
        loading: "lazy",
        style: {
            border: 0
        }
    }));
export default YouTube;
